import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

// TODO: replace pageID and elementID with the real RBAC IDs from the backend.
export const AdjacentHubListRBAC = {
  pageID: '7f5efa5c9f67fcb80924ea42cc9f427c',
  elementID: {
    ViewPage: '15c02ddbb04dfc157052b20f7ff62b17',
    Create: '9576509311b0119d249a134d86510c70',
    Edit: '15c071f1d34dfc157052b20f9be12ce0',
    Delete: '46b6ffe9c9b0119d249a0003d9c10de5',
  },
} as const

export const useRBACAdjacentHubList = createUseRBAC(AdjacentHubListRBAC.elementID)

export type UseRBACAdjacentHubListType = ReturnType<typeof useRBACAdjacentHubList>
